import LazyYoutube from "../LazyYouTube"

export default function VideoBlock({videos}) {    
  
    return (
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {videos && (
            videos.map((item) => (
                <div key={item._key}>
                    <LazyYoutube videoFile={item} />
                </div>
                ))
        )}        
      </div>
    )
  }